import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ShiftDto } from "./shift.dto";

export class    ShiftResponseModel extends GlobalResponseObject{
    data?: ShiftDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: ShiftDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}